import { ethers } from 'ethers';
import { useMemo } from 'react';

export function useChecksumAddress(address: string): string {
  return useMemo(() => {
    try {
      return ethers.getAddress(address);
    } catch (error) {
      return address;
    }
  }, [address]);
}
